const mainNav = () => {
  const indicator = document.querySelector('.a1now-mainnav__indicator');
  const menuItems = document.querySelectorAll('.a1now-mainnav__ul > .menu-item');

  [].forEach.call(menuItems, mi => {
    const menuItem = mi;

    menuItem.onmouseover = () => {
      const itemA = menuItem.querySelector('a');
      indicator.style.width = `${itemA.offsetWidth}px`;
      indicator.style.left = `${itemA.offsetLeft}px`;
    };
    menuItem.onmouseout = () => {
      indicator.removeAttribute('style');
    };
  });

  document.querySelector('.a1now-mobileoverlay-trigger').onclick = e => {
    e.preventDefault();
    e.target.classList.toggle('is-active');
    document.querySelector('body').classList.toggle('mobileoverlay-active');
    document.querySelector('.a1now-mobileoverlay').setAttribute('aria-hidden', (i, attr) => {
      return attr === 'true' ? 'false' : 'true';
    });
  };

  document.querySelector('.a1now-mobileoverlay__close').onclick = () => {
    document.querySelector('.a1now-mobileoverlay-trigger').click();
  };

  const menuItemsMobile = document.querySelectorAll('.a1now-mainnavmobile__ul > .menu-item > a');
  [].forEach.call(menuItemsMobile, mim => {
    const menuItemMobile = mim;
    menuItemMobile.onclick = () => {
      document.querySelector('.a1now-mobileoverlay-trigger').click();
    };
  });
};

const features = () => {
  const indicator = document.querySelector('.a1now-home-features__overview-indicator');
  const featureItems = document.querySelector('.a1now-home-features');

  if (featureItems === null) return;

  const featureTriggers = featureItems.querySelectorAll(
    '.a1now-home_features__overview-one-feature-trigger'
  );
  const featureContent = featureItems.querySelectorAll('.a1now-home_features__content-one-feature');

  let clickedTab = featureItems.querySelector(
    '.a1now-home_features__overview-one-feature-trigger.is-active'
  );
  const tabContent = featureItems.querySelector('.a1now-home-features__content');
  let activeTabContent = tabContent.querySelector(
    '.a1now-home_features__content-one-feature.is-active'
  );

  indicator.style.width = `${clickedTab.offsetWidth}px`;

  activeTabContent.style.display = 'block';

  tabContent.style.height = `${activeTabContent.offsetHeight}px`;

  [].forEach.call(featureTriggers, ft => {
    const featureTrigger = ft;

    featureTrigger.onclick = e => {
      e.preventDefault();

      if (featureTrigger.classList.contains('is-active')) return false;

      clickedTab.classList.remove('is-active');
      clickedTab.setAttribute('aria-selected', false);

      clickedTab = featureTrigger;

      clickedTab.classList.add('is-active');
      clickedTab.setAttribute('aria-selected', true);

      indicator.style.width = `${clickedTab.offsetWidth}px`;
      indicator.style.left = `${clickedTab.offsetLeft}px`;

      activeTabContent.classList.remove('is-active');
      activeTabContent.setAttribute('aria-hidden', true);
      activeTabContent.style.display = 'none';

      const clickedTabIndex = [].indexOf.call(featureTriggers, featureTrigger);

      activeTabContent = featureContent[clickedTabIndex];

      activeTabContent.classList.add('is-active');
      activeTabContent.setAttribute('aria-hidden', false);
      activeTabContent.style.display = 'block';

      tabContent.style.height = `${activeTabContent.offsetHeight}px`;

      return null;
    };
  });
};

const accordions = () => {
  [].forEach.call(document.querySelectorAll('.a1now-accordion'), accordionElem => {
    [].forEach.call(accordionElem.querySelectorAll('.a1now-accordion__item'), ai => {
      const accordionItem = ai;

      accordionItem.querySelector('.a1now-accordion__item-header > a').onclick = e => {
        e.preventDefault();
        const accordionItemBody = accordionItem.querySelector('.a1now-accordion__item-body');
        const accordionItemBodyContents = accordionItemBody.querySelector(
          '.a1now-accordion__item-contents'
        );

        if (accordionItem.classList.contains('is-expanded')) {
          accordionItemBody.style.maxHeight = 0;
          accordionItem.classList.remove('is-expanded');
        } else {
          accordionItemBody.style.maxHeight = `${accordionItemBodyContents.clientHeight}px`;
          accordionItem.classList.add('is-expanded');
        }

        [].forEach.call(accordionItemBodyContents.querySelectorAll('.responsiveEmbed'), re => {
          const ifr = re.getElementsByTagName('iframe')[0].contentWindow;
          if (!!ifr) {
            ifr.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      };
    });
  });
};

const tvchannels = () => {
  [].forEach.call(document.querySelectorAll('.tvLogo > img'), tvLI => {
    const tvLogoImg = tvLI;

    tvLogoImg.onmouseenter = e => {
      e.preventDefault();

      const tgt = tvLogoImg;
      const cD = {};

      cD.ch = tgt.getAttribute('alt');
      cD.cutv = tgt.getAttribute('data-cutv') * 1;
      cD.stovr = tgt.getAttribute('data-stovr') * 1;
      cD.npvr = tgt.getAttribute('data-npvr') * 1;
      cD.dual = tgt.getAttribute('data-dual');
      cD.add = tgt.getAttribute('data-add') * 1;

      let tip = '';

      if (cD.ch) {
        tip += `<div class="funcTitle">${cD.ch}</div>`;

        if (cD.cutv || cD.stovr || cD.npvr || cD.dual || cD.add) {
          if (cD.cutv) {
            let cutvTxt = '';
            if (cD.cutv === 12) cutvTxt = ' до 48ч.';
            tip += `<div class="funcCutvPossible">Функция за връщане назад${cutvTxt}</div>`;
          }
          if (cD.stovr) {
            tip += '<div class="funcStovrPossible">Функция за гледане отначало</div>';
          }
          if (cD.npvr) {
            tip += '<div class="funcNpvrPossible">Функция за запис</div>';
          }
          if (cD.dual) {
            tip += '<div class="funcDualAudio">Функция двуезично аудио</div>';
          }
          if (cD.add) {
            tip += '<div class="tv_ico_ch_add">Допълнителен канал</div>';
          }
        }
      }

      if (!tip || tip === '') return false;

      tgt.setAttribute('title', '');

      const tooltip = document.createElement('div');
      tooltip.setAttribute('id', 'tooltip');
      tooltip.style.opacity = 0;
      tooltip.innerHTML = tip;
      document.body.appendChild(tooltip);

      const initTooltip = () => {
        const ddE = document.documentElement;
        const wWidth = ddE.clientWidth;

        const tgtRect = tgt.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        if (wWidth < tooltip.offsetWidth * 1.5) tooltip.style.maxWidth = `${(wWidth * 2) / 3}px`;
        else tooltip.style.maxWidth = `340px`;

        let posLeft = ddE.scrollLeft + tgtRect.left + tgtRect.width / 2 - tooltipRect.width / 2;
        let posTop = document.documentElement.scrollTop + tgtRect.top - tooltipRect.height - 25;

        if (posLeft < 0) {
          posLeft = ddE.scrollLeft + tgtRect.left + tgtRect.width / 2 - 20;
          tooltip.classList.add('left');
        } else tooltip.classList.remove('left');

        if (posLeft + tooltipRect.width > wWidth) {
          posLeft = ddE.scrollLeft + tgtRect.left - tooltipRect.width + tgtRect.width / 2 + 20;
          tooltip.classList.add('right');
        } else tooltip.classList.remove('right');

        if (posTop < 0) {
          posTop = ddE.scrollLeft + tgtRect.top + tgtRect.height;
          tooltip.classList.add('top');
        } else tooltip.classList.remove('top');

        tooltip.style.left = `${posLeft}px`;
        tooltip.style.top = `${posTop}px`;
        tooltip.style.opacity = 1;
      };

      initTooltip();
      window.addEventListener('resize', initTooltip);

      const removeTooltip = () => {
        const tt = document.getElementById('tooltip');
        if (tt) tt.parentNode.removeChild(tt);
      };

      tgt.addEventListener('mouseleave', removeTooltip);
      tooltip.addEventListener('click', removeTooltip);
      window.addEventListener('scroll', removeTooltip);

      return null;
    };
  });

  return null;
};

export { mainNav, features, accordions, tvchannels };
